import gravatar from './gravatar.js';
import tips from './tips.js';
import welcome from './welcome.js';

export default {
    gravatar,
    tips,
    welcome
};
